// pages/_app.js
import Head from 'next/head';
import Script from 'next/script';
import { IBM_Plex_Sans, IBM_Plex_Serif } from 'next/font/google';
import './styles/globals.css';
import Navbar from '../src/components/home/Navbar';
import ClientFooter from '../src/components/home/ClientFooter';
import mentorshipPrograms from '../src/data/mentorship-programs.json';

// load your fonts as CSS variables
const ibmPlexSans = IBM_Plex_Sans({
  weight: ['400','500','600','700'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-ibm-plex-sans',
});
const ibmPlexSerif = IBM_Plex_Serif({
  weight: ['400','500','600','700'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-ibm-plex-serif',
});

export default function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <link rel="icon" href="/images/favicon-new.svg" />
        <title>GrowthSchool – Become the Top 1%</title>
        <meta
          name="description"
          content="Master the skills you need to become the top 1% in your field at GrowthSchool."
        />
      </Head>


      <Script
        src="https://in.fw-cdn.com/32121956/1131776.js"
        strategy="afterInteractive"
      />

      <div
        className={`antialiased ${ibmPlexSans.variable} ${ibmPlexSerif.variable}`}
      >
        <Navbar programs={mentorshipPrograms} />
        <Component {...pageProps} />
        <ClientFooter />
      </div>
    </>
  );
}
